module.exports = __webpack_public_path__ + "img/火币中国列表.d2de2cae.png";